export const sortDataByNameAndType = (data: any) => {
  return [...data].sort((a, b) => {
    if (a.type === "FOLDER" && b.type === "FILE") return -1;
    if (a.type === "FILE" && b.type === "FOLDER") return 1;

    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();

    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;

    return 0;
  });
};

export const formatDateAndTime = (updateDate: string) => {
  const date = new Date(updateDate + "Z");
  return date.toLocaleDateString() + " " + date.toLocaleTimeString();
};
